export const GET_INSTRUMENT_SECTIONS = "GET_INSTRUMENT_SECTIONS";
export const GET_INSTRUMENT_SECTION_BY_ID = "GET_INSTRUMENT_SECTION_BY_ID";
export const UPDATE_INSTRUMENT_SECTION = "UPDATE_INSTRUMENT_SECTION";
export const DELETE_INSTRUMENT_SECTION = "DELETE_INSTRUMENT_SECTION";
export const CREATE_INSTRUMENT_SECTION = "CREATE_INSTRUMENT_SECTION";
export const GET_INSTRUMENT_SECTION_MUSICIANS =
  "GET_INSTRUMENT_SECTION_MUSICIANS";
export const GET_MUSICIAN_INSTRUMENT_FOR_SECTION =
  "GET_MUSICIAN_INSTRUMENT_FOR_SECTION";
